import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-28 sm:py-36" data-id="element-92" data-mp="vg7pvxdc1yh7">
      <div className="mx-auto flex w-full max-w-[1120px] flex-col items-center text-center" data-id="element-93" data-mp="19eyyx5dc8tyh">
        <Reveal data-id="element-94" data-mp="15ddgz5ly5phf">
          <h2 className="max-w-3xl font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-white sm:text-6xl" data-id="element-95" data-mp="15cubiodhgtka">
            Klar til{' '}
            <span className="font-serif text-[0.9em] normal-case italic text-gold" data-id="element-96" data-mp="1jbadk20ehvw3">
              aldrig mere
            </span>{' '}
            at stå i hallen uden en plan?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-97" data-mp="1t50ywy18dq7k">
          <p className="mx-auto mt-7 max-w-[600px] text-base leading-relaxed text-white/70 sm:text-[17px]" data-id="element-98" data-mp="1o43hino1p074">
            Seks bind, fem bonusser og 36 uger, der allerede er lagt.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="w-full max-w-lg" data-id="element-99" data-mp="1x51onets5ntx">
          <div className="mt-12 w-full" data-id="element-100" data-mp="1x2gpixkv9lzv">
            <CtaButton label="Hent Håndboldklar — 249 kr." data-id="element-101" data-mp="n6e3fhgh49u9" />
          </div>
        </Reveal>

        <Reveal delay={0.16} data-id="element-102" data-mp="s45u685dtpwv">
          <p className="mt-4 text-sm text-white/60" data-id="element-103" data-mp="s5gzwdie17qm">
            Samlet værdi 1.339 kr. · Du sparer 1.090 kr. · 30 dages garanti
          </p>
        </Reveal>
      </div>
    </section>;
}